const VAR_CORE_GEOMETRY = `coreGeometry`;
export class AttributeRequirementsController {
  constructor() {
  }
  reset() {
    if (this._attributeNames) {
      this._attributeNames.clear();
    }
  }
  assignAttributesLines() {
    if (this._attributeNames) {
      const lines = [];
      for (let attribName of this._attributeNames) {
        lines.push(AttributeRequirementsController.assignAttributeLine(attribName));
      }
      return lines.join(";\n");
    } else {
      return "";
    }
  }
  assignArraysLines() {
    if (this._attributeNames) {
      const lines = [];
      if (this._attributeNames.size > 0) {
        const coreGeoLine = `const ${VAR_CORE_GEOMETRY} = entities[0].coreGeometry();`;
        lines.push(coreGeoLine);
      }
      for (let attribName of this._attributeNames) {
        lines.push(AttributeRequirementsController.assignItemSizeLine(attribName));
        lines.push(AttributeRequirementsController.assignArrayLine(attribName));
      }
      return lines.join(";\n");
    } else {
      return "";
    }
  }
  attributePresenceCheckLine() {
    if (this._attributeNames) {
      const varNames = [];
      for (let attribName of this._attributeNames) {
        const varName = AttributeRequirementsController._varAttribute(attribName);
        varNames.push(varName);
      }
      if (varNames.length > 0) {
        return varNames.join(" && ");
      }
    }
    return "true";
  }
  add(attribName) {
    this._attributeNames = this._attributeNames || /* @__PURE__ */ new Set();
    this._attributeNames.add(attribName);
  }
  static assignAttributeLine(attribName) {
    const varAttribute = this._varAttribute(attribName);
    return `const ${varAttribute} = getEntitiesAttribute(entities,'${attribName}')`;
  }
  static assignItemSizeLine(attribName) {
    const varAttribute = this._varAttribute(attribName);
    const varAttributeSize = this._varAttribSize(attribName);
    return `const ${varAttributeSize} = ${varAttribute}.itemSize`;
  }
  static assignArrayLine(attribName) {
    const varAttribute = this._varAttribute(attribName);
    const varArray = this._varArray(attribName);
    const isIndexedCondition = `${VAR_CORE_GEOMETRY}.isAttribIndexed('${attribName}')`;
    const indexedArray = `entities.map(e=>e.indexedAttribValue('${attribName}'))`;
    const nonIndexedArray = `${varAttribute}.array`;
    return `const ${varArray} = ${isIndexedCondition} ? ${indexedArray} : ${nonIndexedArray}`;
  }
  static _varAttribute(attribName) {
    return `attrib_${attribName}`;
  }
  static _varAttribSize(attribName) {
    return `attrib_size_${attribName}`;
  }
  static _varArray(attribName) {
    return `array_${attribName}`;
  }
  varAttributeSize(attribName) {
    return AttributeRequirementsController._varAttribSize(attribName);
  }
  varArray(attribName) {
    return AttributeRequirementsController._varArray(attribName);
  }
}
